<!-- 随访管理 -->
<template>
  <div class="app-container">
    <el-container direction="vertical">
      <el-row>
        <el-row>
          <div style="font-size: 32;font-weight: bolder;">随访管理</div>
        </el-row>
        <el-row style="background-color: #d5d5d5;height: 0.5px;width: 100%;margin-top: 20px;" />
      </el-row>

      <el-row style="margin-top: 30px;">
        <div style="border: 1px solid #eee">
          <el-row>
            <el-col style="margin-top: 10px; margin-left: 10px">
              <el-form id="form" style="display: flex">
                <el-form-item label="时间">
                  <el-date-picker v-model="time" @change="dateChange" type="daterange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" style="margin-left: 20px" @click="getList">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button style="margin-left: 20px" @click="openCustomTagDialog">标签管理</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>

          <el-row>
            <el-table v-loading="listLoading" :data="list" height="500px" fit highlight-current-row
              style="width: 100%; margin-top: 20px">
              <el-table-column align="center" label="状态">
                <template slot-scope="scope">
                  <span>{{ scope.row.status ? scope.row.status : "未随访" }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="随访时间">
                <template slot-scope="scope">
                  <span>{{ getParsedTime(scope.row.startTime) }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="姓名">
                <template slot-scope="scope">
                  <span>{{ scope.row.patientName }}</span>
                </template>
              </el-table-column>

              <el-table-column width="170px" align="center" label="身份证号">
                <template slot-scope="scope">
                  <span>{{ scope.row.idcard }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="性别" width="50px">
                <template slot-scope="scope">
                  <span>{{ getGender(scope.row.gender) }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="出生日期">
                <template slot-scope="scope">
                  <span>{{ scope.row.birthday }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="年龄" width="50px">
                <template slot-scope="scope">
                  <span>{{ getAge(scope.row.birthday) }}</span>
                </template>
              </el-table-column>

              <!-- <el-table-column align="center" label="居住地址">
                <template slot-scope="scope">
                  <span>{{ scope.row.village }}</span>
                </template>
              </el-table-column> -->

              <!-- <el-table-column align="center" label="联系人">
              <template slot-scope="scope">
                <span>{{ scope.row.contactName }}</span>
              </template>
            </el-table-column> -->

              <el-table-column align="center" label="本人电话">
                <template slot-scope="scope">
                  <span>{{ scope.row.phone }}</span>
                </template>
              </el-table-column>
              <!-- 
            <el-table-column align="center" label="建档时间">
              <template slot-scope="scope">
                <span>{{ scope.row.createTime }}</span>
              </template>
            </el-table-column> -->

              <!-- <el-table-column align="center" label="所属机构">
                <template slot-scope="scope">
                  <span>{{ scope.row.managerHospital }}</span>
                </template>
              </el-table-column> -->

              <el-table-column fixed="right" align="center" label="操作" width="200">
                <template slot-scope="scope">
                  <!-- <el-button style="margin-left: 0px; align-self: center" type="text" @click="onEdit(scope.row)">
                    编辑
                  </el-button>

                  <el-button style="margin-left: 10px; align-self: center" type="text" @click="onDetail(scope.row)">
                    详情
                  </el-button> -->

                  <el-button style="margin-left: 0px; align-self: center" type="text" @click="onEdit(scope.row)">
                    随访
                  </el-button>

                  <!-- <el-button style="margin-left: 0px; align-self: center" type="text" @click="onEdit(scope.row)">
                    编辑
                  </el-button> -->
                </template>
              </el-table-column>
              <el-table-column align="center" label="提醒与分配" width="220">
                <template slot-scope="scope">
                  <el-button v-if="shouldShowTodayReminder(scope.row)" type="text" @click="remind(scope.row,'first')">今日提醒</el-button>
                  <el-button v-else-if="shouldShowWeekReminder(scope.row)" type="text" @click="remind(scope.row,'second')">一周提醒</el-button>
                  <el-button v-else-if="shouldShowAssign(scope.row)" type="text" @click="assign(scope.row)">分配医生任务</el-button>
                  <span v-else>无</span>
                </template>
              </el-table-column>
            </el-table>
          </el-row>

          <el-row>
            <pagination v-show="total > 0" :total="total" :page.sync="formData.pageNum" :limit.sync="formData.pageSize"
              @pagination="turnToPage" />
          </el-row>

          <new-follow-up v-if="newFollowUpVisible" ref="NewFollowUpRef"></new-follow-up>

          <follow-up-detail v-if="followUpDetailVisible" ref="FollowUpDetailRef"></follow-up-detail>

          <edit-follow-up v-if="editFollowUpVisible" ref="EditFollowUpRef" @updateList="updateList"
            @addEventPlan="getList"></edit-follow-up>

          <edit-discharge-follow-up v-if="editDischargeFollowUpVisible" ref="EditDischargeFollowUpRef"
            @updateList="updateList" @addEventPlan="getList"></edit-discharge-follow-up>

          <discharge-follow-up-detail v-if="dischargeFollowUpDetailVisible"
            ref="DischargeFollowUpDetailRef"></discharge-follow-up-detail>
          
          <el-dialog title="标签管理" :visible.sync="customTagDialogVisible" width="500px">
            <el-form :model="newTagForm" label-width="80px">
              <el-form-item label="标签名">
                <el-input v-model="newTagForm.name"></el-input>
              </el-form-item>
              <el-form-item label="分类">
                <el-select v-model="newTagForm.category" placeholder="请选择">
                  <el-option v-for="opt in customTagOptions" :key="opt" :label="opt" :value="opt"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div style="margin-top:10px">
              <el-button type="primary" @click="submitNewTag">添加标签</el-button>
              <el-button @click="customTagDialogVisible=false">关闭</el-button>
            </div>
            <div style="margin-top:20px">
              <div>当前自定义标签：</div>
              <el-tag v-for="tag in customTags" :key="tag.id" style="margin-right:8px">{{tag.name}}/{{tag.category}}</el-tag>
            </div>
          </el-dialog>
        </div>
      </el-row>
    </el-container>
  </div>
</template>

<script>
import {
  getListByTime,
  getPatientFollowupRecord,
  getFollowupValue,
  turnToListByTime,
  getSysDicList,
  remindFollowup,
  assignFollowupToDoctor,
  listCustomLabels,
  addCustomLabel
} from "@/api/health/Patients.js";
import Pagination from "@/components/Pagination";
import { deleteFollowUp } from "@/api/health/FollowUpQuery";
import moment from "moment";
import newFollowUp from "./followUp/newFollowUp.vue";
import followUpDetail from "./followUp/followUpDetail.vue";
import editFollowUp from "./followUp/editFollowUp.vue";
import editDischargeFollowUp from "./followUp/editDischargeFollowUp.vue";
import dischargeFollowUpDetail from "./followUp/dischargeFollowUpDetail.vue";

export default {
  components: {
    newFollowUp,
    followUpDetail,
    editFollowUp,
    editDischargeFollowUp,
    dischargeFollowUpDetail,
    Pagination,
  },
  props: {
    pInfo: null,
  },
  data() {
    return {
      newFollowUpVisible: false,
      editFollowUpVisible: false,
      followUpDetailVisible: false,
      editDischargeFollowUpVisible: false,
      dischargeFollowUpDetailVisible: false,
      update: true,
      total: 0,
      name: "",
      listLoading: false,
      list: [],
      lstDataResult: [],
      formData: {
        pageNum: 1,
        pageSize: 10,
      },
      listQuery: {
        idcard: null,
        startTime: null,
        endTime: null,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近半年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      time: [],
      deleteParam: {
        planId: "",
      },
      deleteFollowUpParam: {
        id: "",
      },
      sexOptions: [],
      customTagDialogVisible: false,
      newTagForm: {
        name: "",
        category: ""
      },
      customTagOptions: ["肺占位","肺肿瘤","肺癌"],
      customTags: []
    };
  },
  created() {
    var typeData = "性别";
    this.getSystemDictList(typeData);

    this.listQuery.idcard = this.pInfo.idcard;
    this.getList();
  },
  methods: {
    getSystemDictList(typeName) {
      var typeData = {
        "typeName": typeName
      };
      getSysDicList(typeData).then(res => {
        var records = [];
        if (res.msg == "success") {
          var data = res.data;
          records = data.records;
        }
        this.sexOptions = records;
      }).catch(err => {
        console.log(err);
      })
    },
    // 刷新列表
    updateList() {
      this.getList();
    },
    dateChange() {
      this.listQuery.startTime = this.getDate(this.time[0]);
      this.listQuery.endTime = this.getDate(this.time[1]);
      console.log("=======时间========", this.time);
    },
    getList() {
      this.list = [];
      this.listLoading = true;
      getListByTime(this.listQuery).then((response) => {
        this.listLoading = false;
        this.total = response.data.total;
        this.list = response.data.records;
        this.lstDataResult = response.data;
        this.list.sort(function (a, b) {
          return b.createDate < a.createDate ? -1 : 1;
        });
        this.enrichFollowupSchedule();
      });
    },
    // 导航跳转查询列表页
    turnToPage() {
      let params = Object.assign({}, this.listQuery, this.formData);
      this.listLoading = true;
      turnToListByTime(params).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.list = res.data.records;
          this.list.sort(function (a, b) {
            return b.createDate < a.createDate ? -1 : 1;
          });
          this.total = res.data.total;
        }
      });
    },
    onEdit(row) {

      console.log('编辑该条随访详情：', row);

      row["pInfo"] = this.pInfo;

      let params = {
        idcard: row.idcard,
        paramNames: ['空腹血糖']
      }

      var data = {
        idcard: row.idcard,
        status: "已完成"
      }

      let params2 = {
        id: row.id
      }

      if (row.status == "已完成") {
        getPatientFollowupRecord(params2)
          .then((res) => {
            if (res.msg == "success") {
              row["records"] = res.data;
              getFollowupValue(params).then((response) => {
                if (response.msg == "success") {
                  // if (response.data.length > 0) {
                  if (response.data.length > 0) {
                    var resData = response.data[0];
                    row.bloodSuger = resData.paramValue;
                    row.nextFollowupTime = resData.nextFollowupTime;
                    row.bloodsugarTime = resData.checkTime;
                  }
                  this.editFollowUpVisible = true;
                  this.$nextTick(() => {
                    this.$refs.EditFollowUpRef.init(row);
                  });
                  // } else {
                  //   this.$message({
                  //     message: "该患者暂无血糖值，请获取最新血糖值！",
                  //     type: "error",
                  //   });
                  // }
                }
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        getListByTime(data).then((res) => {
          if (res.msg == "success") {
            row["records"] = res.data.records[0];
            getFollowupValue(params).then((response) => {
              if (response.msg == "success") {
                // if (response.data.length > 0) {
                if (response.data.length > 0) {
                  var resData = response.data[0];
                  row.bloodSuger = resData.paramValue;
                  row.nextFollowupTime = resData.nextFollowupTime;
                  row.bloodsugarTime = resData.checkTime;
                }
                this.editFollowUpVisible = true;
                this.$nextTick(() => {
                  this.$refs.EditFollowUpRef.init(row);
                });
                // } else {
                //   this.$message({
                //     message: "该患者暂无血糖值，请获取最新血糖值！",
                //     type: "error",
                //   });
                // }
              }
            });
          }
        });
      }
    },
    // onEdit(row) {
    //   console.log("基本信息：", row);
    //   row["pInfo"] = this.pInfo;

    //   if (row.serviceName == "出院随访") {
    //     this.editDischargeFollowUpVisible = true;
    //     this.$nextTick(() => {
    //       this.$refs.EditDischargeFollowUpRef.init(row);
    //     });
    //   } else {
    //     let params = {
    //       id: row.id,
    //       idcard: row.idcard,
    //       serviceType: "糖尿病",
    //     };
    //     var data = {
    //       idcard: row.idcard,
    //       status: "已完成",
    //     };

    //     if (row.status == "已完成") {
    //       getPatientFollowupRecord(params)
    //         .then((res) => {
    //           if (res.msg == "success") {
    //             row["data"] = res.data;
    //             getFollowupValue(params).then((response) => {
    //               if (response.msg == "success") {
    //                 if (response.data) {
    //                   row.bloodSuger = response.data.bloodSuger;
    //                   row.nextFollowupTime = response.data.nextFollowupTime;
    //                   row.bloodsugarTime = response.data.startTime;
    //                   this.editFollowUpVisible = true;
    //                   this.$nextTick(() => {
    //                     this.$refs.EditFollowUpRef.init(row);
    //                   });
    //                 } else {
    //                   this.$message({
    //                     message: "该患者暂无血糖值，请获取最新血糖值！",
    //                     type: "error",
    //                   });
    //                 }
    //               }
    //             });
    //           }
    //         })
    //         .catch((error) => {
    //           console.log(error);
    //         });
    //     } else {
    //       getListByTime(data).then((res) => {
    //         if (res.msg == "success") {
    //           row["data"] = res.data.records[0];
    //           getFollowupValue(params).then((response) => {
    //             if (response.msg == "success") {
    //               if (response.data) {
    //                 row.bloodSuger = response.data.bloodSuger;
    //                 row.nextFollowupTime = response.data.nextFollowupTime;
    //                 row.bloodsugarTime = response.data.startTime;
    //                 this.editFollowUpVisible = true;
    //                 this.$nextTick(() => {
    //                   this.$refs.EditFollowUpRef.init(row);
    //                 });
    //               } else {
    //                 this.$message({
    //                   message: "该患者暂无血糖值，请获取最新血糖值！",
    //                   type: "error",
    //                 });
    //               }
    //             }
    //           });
    //         }
    //       });
    //     }
    //   }
    // },
    onDetail(row) {
      console.log(row, "baseInfo ");
      row["pInfo"] = this.pInfo;

      if (row.serviceName == "出院随访") {
        this.dischargeFollowUpDetailVisible = true;
        this.$nextTick(() => {
          this.$refs.DischargeFollowUpDetailRef.init(row);
        });
      } else {
        let params = {
          id: row.id,
          idcard: row.idcard,
          serviceType: "糖尿病",
        };
        getPatientFollowupRecord(params)
          .then((res) => {
            console.log(res);
            if (res.msg == "success") {
              row["data"] = res.data;
              getFollowupValue(params).then((response) => {
                if (response.msg == "success") {
                  // if (response.data) {
                  if (response.data) {
                    row.bloodSuger = response.data.bloodSuger;
                    row.nextFollowupTime = response.data.nextFollowupTime;
                  }
                  this.followUpDetailVisible = true;
                  this.$nextTick(() => {
                    this.$refs.FollowUpDetailRef.init(row);
                  });
                  // } else {
                  //   this.$message({
                  //     message: "该患者暂无血糖值，请获取最新血糖值！",
                  //     type: "error",
                  //   });
                  // }
                }
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    //新建随访
    patientFollowup(row) {
      this.newFollowUpVisible = true;
      this.$nextTick(() => {
        this.$refs["newFollowUpRef"].init(row);
      });
    },
    deleteFollowUp(followUpId) {
      this.deleteFollowUpParam.id = followUpId;
      deleteFollowUp(this.deleteFollowUpParam).then((response) => {
        console.log(response);
      });
    },
    getDate(time) {
      var newTime = new Date(time);
      return (
        newTime.getFullYear() +
        "-" +
        (newTime.getMonth() + 1) +
        "-" +
        newTime.getDate()
      );
    },
    convertTime(row) {
      var dt = Date.parse(row);
      var str = moment(new Date(parseInt(dt))).format("YYYY-MM-DD HH:mm");
      return str;
    },
    // 计算当前年龄
    getAge(birthday) {
      if (birthday == null) return "";

      var birthdays = new Date(birthday.replace(/-/g, "/"));
      let d = new Date();
      let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
          ? 1
          : 0);
      return age;
    },
    getGender(gender) {
      var option = this.sexOptions.filter(v => v.value == gender)[0];
      return option.name;
    },
    getParsedTime(time) {
      return moment(time).format("YYYY-MM-DD HH:mm");
    },
    enrichFollowupSchedule() {
      const tasks = this.list.map(row => {
        const params = { idcard: row.idcard, paramNames: ['空腹血糖'] }
        return getFollowupValue(params).then((response) => {
          if (response.msg == "success" && response.data && response.data.length > 0) {
            const resData = response.data[0];
            this.$set(row, 'nextFollowupTime', resData.nextFollowupTime);
          }
        })
      })
      Promise.all(tasks).then(() => {})
    },
    shouldShowTodayReminder(row) {
      if (row.status == "已完成") return false
      const base = row.nextFollowupTime || row.startTime
      if (!base) return false
      const d = moment(base).format("YYYY-MM-DD")
      const t = moment().format("YYYY-MM-DD")
      return d === t
    },
    shouldShowWeekReminder(row) {
      if (row.status == "已完成") return false
      const base = row.nextFollowupTime || row.startTime
      if (!base) return false
      const diff = moment().diff(moment(base), 'days')
      return diff >= 7 && diff < 14
    },
    shouldShowAssign(row) {
      if (row.status == "已完成") return false
      const base = row.nextFollowupTime || row.startTime
      if (!base) return false
      const diff = moment().diff(moment(base), 'days')
      return diff >= 14
    },
    remind(row, stage) {
      const payload = {
        idcard: row.idcard,
        followupId: row.id,
        scheduleDate: row.nextFollowupTime || row.startTime,
        stage: stage
      }
      remindFollowup(payload).then(res => {
        if (res.msg == "success") {
          this.$message({ message: '已发送提醒', type: 'success' })
        }
      })
    },
    assign(row) {
      const payload = {
        idcard: row.idcard,
        followupId: row.id
      }
      assignFollowupToDoctor(payload).then(res => {
        if (res.msg == "success") {
          this.$message({ message: '已分配医生任务', type: 'success' })
        }
      })
    },
    openCustomTagDialog() {
      this.customTagDialogVisible = true
      const query = { idcard: this.pInfo.idcard }
      listCustomLabels(query).then(res => {
        if (res.msg == "success") {
          this.customTags = res.data.records || []
        }
      })
    },
    submitNewTag() {
      const payload = {
        idcard: this.pInfo.idcard,
        name: this.newTagForm.name,
        category: this.newTagForm.category
      }
      if (!payload.name || !payload.category) return
      addCustomLabel(payload).then(res => {
        if (res.msg == "success") {
          this.$message({ message: '已添加自定义标签', type: 'success' })
          this.newTagForm = { name: "", category: "" }
          this.openCustomTagDialog()
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 10px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 1000px;
}

#form::v-deep {
  .el-input {
    width: 350px;
  }

  .el-form-item__content {
    display: inline-block;
    margin-right: 20px;
  }
}

.app-container #form ::v-deep {
  .el-form .el-form-item__label {
    width: auto !important;
  }
}
</style>
